"use client";

import { type JSX, useState } from "react";

import { progressSingleton } from "@/singletons/progress.singleton";

export const ProgressView = (): JSX.Element | null => {
    const [progress, setProgress] = useState(0);

    progressSingleton.onChange((p) => {
        setProgress(p);
    });

    if (progress) {
        return (
            <div
                className="fixed z-1000 top-0 left-0 bg-brandYellow h-[3px]"
                style={{
                    width: `${progress}%`,
                }}
            />
        );
    } else {
        return null;
    }
};
